var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDestiny(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 494.4 461.4",
    style: {
      enableBackground: "new 0 0 494.4 461.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M167.8,48.6c3.4,1.9,5.5,5.4,5.5,9.3c0.3,31.4-0.1,62-0.1,96.3c0,10.9-0.6,21.8,0,32 c2.6,49.4,49.1,85.4,99.2,67.2c24.3-8.8,44.1-30,47.8-59.1c2.3-18.3,0.5-46.1,0.5-70.8V69.9c0-3-0.2-7.2-0.2-11c0-4,2.1-7.7,5.6-9.6 c4.1-2.2,9.2-5.1,10.9-6.1c16.3-9.5,29.5-20.1,49.1-25.7c32.4-9.1,58,7.4,72.6,22.6c16,16.7,26.7,45.6,16.7,75.4 c-8.5,25-28.9,36.5-49.1,50.5c-39.2,27.1-69.2,63.6-87.9,111.8c-9,23.1-14.2,53.7-17.1,81.6c-1.7,16.5-2.6,30.2-7.7,42.4 c-9.2,22.1-28,40.2-55.9,43.7c-47.5,5.9-76.4-24.7-82.5-65.4c-2.3-15.4-2.9-30.6-5-45.1c-10.1-71.4-43.8-123.3-90.2-159.6 C52.1,153.6,13.9,139,15,90.7c0.4-13.5,4.3-26.8,11.3-38.3c12-19.5,32.8-36.8,64-37C124.9,15.1,142.8,34.8,167.8,48.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M245.5,51.8c17.9-1.4,33.3,14,36.8,33.2c2,10.9,0.7,31.8,0.7,43.4c0,13.8,1,31.1-0.3,43.8 c-1.1,12.3-6.7,23.4-15.2,30.4c-22.1,17.5-53.5,1.9-56.3-32c-1.3-15.8,0-30.9,0-46.6c0-15.2-1.2-33.4,2-44.2 C217.3,65.6,229,53,245.5,51.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestiny);
export default __webpack_public_path__ + "static/media/destiny.c26fcc1c80a820b5aa2e4f87cf951a5d.svg";
export { ForwardRef as ReactComponent };